/* Awa Woodworks — minimal behaviour, no dependencies */
(function () {
  'use strict';

  /* Sticky header shadow once scrolled */
  var hdr = document.querySelector('.site-header');
  if (hdr) {
    var onHdrScroll = function () { hdr.classList.toggle('is-stuck', window.scrollY > 8); };
    window.addEventListener('scroll', onHdrScroll, { passive: true });
    onHdrScroll();
  }

  /* Mobile menu */
  var toggle = document.querySelector('.menu-toggle');
  var nav = document.querySelector('.site-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Reveal on scroll — enhancement only; probe proves IO works before hiding anything */
  var revealAll = function () {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  };
  if ('IntersectionObserver' in window) {
    var probeOk = false;
    var probe = new IntersectionObserver(function () {
      probeOk = true;
      probe.disconnect();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.12 });
      document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
      setTimeout(revealAll, 4000);
    });
    probe.observe(document.body);
    setTimeout(function () { if (!probeOk) { probe.disconnect(); revealAll(); } }, 800);
  } else {
    revealAll();
  }

  /* Mobile bottom nav: active state + "More" sheet */
  var here = location.pathname.replace(/\/$/, '') || '/';
  document.querySelectorAll('.bottom-nav a[href]').forEach(function (a) {
    var target = a.getAttribute('href').replace(/\/$/, '') || '/';
    if (target === here || (target !== '/' && here.indexOf(target) === 0)) a.classList.add('is-active');
  });
  var moreBtn = document.querySelector('[data-sheet-open]');
  var scrim = document.querySelector('.nav-sheet-scrim');
  var closeSheet = function () { document.body.classList.remove('sheet-open'); };
  if (moreBtn) moreBtn.addEventListener('click', function () { document.body.classList.toggle('sheet-open'); });
  if (scrim) scrim.addEventListener('click', closeSheet);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });

  /* Species cards: click opens the living-tree lightbox */
  var lb = document.querySelector('[data-tree-lightbox]');
  if (lb) {
    var lbImg = lb.querySelector('img');
    var lbCap = lb.querySelector('.cap');
    var lbCredit = lb.querySelector('.credit');
    var openTree = function (card) {
      lbImg.src = card.dataset.tree;
      lbImg.alt = card.dataset.name || '';
      lbCap.textContent = card.dataset.name || '';
      lbCredit.textContent = card.dataset.credit || '';
      lb.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    };
    var closeTree = function () {
      lb.classList.remove('is-open');
      document.body.style.overflow = '';
    };
    document.querySelectorAll('.species-card--tree').forEach(function (card) {
      card.addEventListener('click', function () { openTree(card); });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openTree(card); }
      });
    });
    lb.addEventListener('click', closeTree);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeTree(); });
  }

  /* Cart quantity buttons */
  document.querySelectorAll('.cart-qty').forEach(function (qty) {
    var input = qty.querySelector('input');
    qty.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        input.value = Math.max(0, v + (btn.dataset.dir === 'up' ? 1 : -1));
        if (input.form) input.form.submit();
      });
    });
  });
})();
